import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getPlanBadgeColors(plan: string | null): string {
  const normalizedPlan = plan?.toLowerCase() || 'basic';
  
  switch (normalizedPlan) {
    case 'pro':
      return 'bg-gradient-to-r from-blue-400 to-blue-500 hover:from-blue-500 hover:to-blue-600 text-white';
    case 'premium':
      return 'bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-black';
    default: // Basic or any other plan
      return 'bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white';
  }
} 